import { downgradeInjectable } from '@angular/upgrade/static';
import * as angular from 'angular';
import { QuicksightService } from './quicksight.service';

export const Ng1QuicksightModule = angular
  .module('control-room.shared.services.quicksight', [])
  .factory('crQuicksightService', downgradeInjectable(QuicksightService));